import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { IPkSk, IRole } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { createAction, props } from '@ngrx/store';

export const getAllRoles = createAction('[ROLE] Get All roles');
export const getAllRoleSuccess = createAction(
	'[ROLE] Get All role success',
	props<{ role: IRole[] }>()
);
export const getAllRoleError = createAction('[ROLE] Get All role error', props<{ error: any }>());

export const cleanRoles = createAction('[ROLE] Clean role ');

export const getRole = createAction('[ROLE] Get role ', props<{ paginationTo: number }>());
export const getRoleSuccess = createAction(
	'[ROLE] Get role success',
	props<{ role: IRole[]; pagination: Pagination }>()
);
export const getRoleError = createAction('[ROLE] Get role error', props<{ error: any }>());

export const getFilterRole = createAction('[ROLE] Get Filter role ', props<{ url: string }>());
export const getFilterRoleSuccess = createAction(
	'[ROLE] Get Filter role success',
	props<{ role: IRole[]; pagination: Pagination }>()
);
export const getFilterRoleError = createAction(
	'[ROLE] Get Filter role error',
	props<{ error: any }>()
);

export const deleteRole = createAction('[ROLE] Delete  role ', props<{ ids: IPkSk[] }>());
export const deleteRoleSuccess = createAction(
	'[ROLE] Delete role success',
	props<{ role: IPkSk[] }>()
);
export const deleteRoleError = createAction('[ROLE] Delete role error', props<{ error: any }>());

export const postRole = createAction('[ROLE] Post role ', props<{ role: IRole }>());
export const postRoleSuccess = createAction('[ROLE] Post role success', props<{ role: IRole }>());
export const postRoleError = createAction('[ROLE] Post role error', props<{ error: any }>());

export const updateRole = createAction('[ROLE] Update role ', props<{ role: IRole; id: IPkSk }>());
export const updateRoleSuccess = createAction(
	'[ROLE] Update role success',
	props<{ role: IRole }>()
);
export const updateRoleError = createAction('[ROLE] Update role error', props<{ error: any }>());
